import { gql } from '@apollo/client';

export const ADDITIONAL_SEARCH_QUERY = gql`
  query additionalSearchQuery {
    client {
      id
      offices {
        id
        name
      }
      employmentTypes
      groups
      positions
    }
  }
`;

export interface AdditionalSearchQuery {
  client: {
    offices: Office[];
    employmentTypes: string[];
    groups: string[];
    positions: string[];
  };
}

export interface Office {
  id: string;
  name: string;
}
